export const URLS = {
  ORIGIN: 'https://origin.trazable.io/',
  OPTICUS: 'https://app.opticus.trazable.io/',
}
